"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.britishColombiaCities = void 0;
exports.britishColombiaCities = [
    {
        label: "100 Mile House",
        value: 8720,
    },
    {
        label: "108 Mile Ranch",
        value: 8317,
    },
    {
        label: "150 Mile House",
        value: 8200,
    },
    {
        label: "70 Mile House",
        value: 8201,
    },
    {
        label: "Abbotsford",
        value: 8210,
    },
    {
        label: "Agassiz",
        value: 8202,
    },
    {
        label: "Alberni",
        value: 8203,
    },
    {
        label: "Albion",
        value: 8204,
    },
    {
        label: "Aldergrove",
        value: 8211,
    },
    {
        label: "Alert Bay",
        value: 8212,
    },
    {
        label: "Alexis Creek",
        value: 8740,
    },
    {
        label: "Alvin",
        value: 8205,
    },
    {
        label: "Anahim Lk.",
        value: 8209,
    },
    {
        label: "Anglemont",
        value: 8206,
    },
    {
        label: "Anmore, BC",
        value: 8268,
    },
    {
        label: "Argenta",
        value: 8213,
    },
    {
        label: "Armstrong, BC",
        value: 8214,
    },
    {
        label: "Arras",
        value: 8341,
    },
    {
        label: "Ashcroft",
        value: 8216,
    },
    {
        label: "Atlin",
        value: 8207,
    },
    {
        label: "Baldonnel",
        value: 8219,
    },
    {
        label: "Balfour",
        value: 8343,
    },
    {
        label: "Bamfield",
        value: 8732,
    },
    {
        label: "Barnston Isl",
        value: 8215,
    },
    {
        label: "Barriere",
        value: 8220,
    },
    {
        label: "Beach Grove",
        value: 8217,
    },
    {
        label: "Beaver Creek",
        value: 8221,
    },
    {
        label: "Beaverdell",
        value: 8344,
    },
    {
        label: "Belcarra",
        value: 8218,
    },
    {
        label: "Bella Bella",
        value: 8223,
    },
    {
        label: "Bella Coola",
        value: 8225,
    },
    {
        label: "Big Creek",
        value: 8637,
    },
    {
        label: "Big Lake",
        value: 8208,
    },
    {
        label: "Black Creek",
        value: 8226,
    },
    {
        label: "Blind Bay",
        value: 8227,
    },
    {
        label: "Blue River",
        value: 8228,
    },
    {
        label: "Boston Bar",
        value: 8229,
    },
    {
        label: "Boswell, BC",
        value: 8279,
    },
    {
        label: "Boundry Bay",
        value: 8722,
    },
    {
        label: "Bowen Island",
        value: 8723,
    },
    {
        label: "Bowser",
        value: 8724,
    },
    {
        label: "Brackendale",
        value: 8725,
    },
    {
        label: "Brentwood Bay",
        value: 8726,
    },
    {
        label: "Bridesville",
        value: 8639,
    },
    {
        label: "Bridge Lake",
        value: 8727,
    },
    {
        label: "Brisco",
        value: 8641,
    },
    {
        label: "Britannia Beach",
        value: 8345,
    },
    {
        label: "Bubble Hill",
        value: 8728,
    },
    {
        label: "Buffalo Creek",
        value: 8361,
    },
    {
        label: "Buick",
        value: 8643,
    },
    {
        label: "Bull River",
        value: 8729,
    },
    {
        label: "Burnaby",
        value: 8636,
    },
    {
        label: "Burns Lake",
        value: 8222,
    },
    {
        label: "Burrard Inlet",
        value: 8224,
    },
    {
        label: "Burton",
        value: 8730,
    },
    {
        label: "Cache Creek",
        value: 8230,
    },
    {
        label: "Campbell River",
        value: 8233,
    },
    {
        label: "Canal Flats",
        value: 8297,
    },
    {
        label: "Canim Lake",
        value: 8363,
    },
    {
        label: "Canoe",
        value: 8364,
    },
    {
        label: "Canyon",
        value: 8235,
    },
    {
        label: "Capiland",
        value: 8231,
    },
    {
        label: "Caribou",
        value: 8239,
    },
    {
        label: "Carson",
        value: 8243,
    },
    {
        label: "Cascade",
        value: 8244,
    },
    {
        label: "Cassiar",
        value: 8245,
    },
    {
        label: "Cassidy",
        value: 8247,
    },
    {
        label: "Castlegar",
        value: 8232,
    },
    {
        label: "Cawston",
        value: 8249,
    },
    {
        label: "Cecil Lake",
        value: 8366,
    },
    {
        label: "Cedar",
        value: 8251,
    },
    {
        label: "Celista",
        value: 8252,
    },
    {
        label: "Central Saanich",
        value: 8676,
    },
    {
        label: "Charlie Lake",
        value: 8253,
    },
    {
        label: "Chase",
        value: 8234,
    },
    {
        label: "Chemainus",
        value: 8254,
    },
    {
        label: "Chetwynd",
        value: 8236,
    },
    {
        label: "Chilanko Forks",
        value: 8255,
    },
    {
        label: "Chilcotin",
        value: 8257,
    },
    {
        label: "Chilko Lake",
        value: 8258,
    },
    {
        label: "Chilliwack",
        value: 8238,
    },
    {
        label: "Chopaka",
        value: 8259,
    },
    {
        label: "Christina Lake",
        value: 8367,
    },
    {
        label: "Clearbrook",
        value: 8260,
    },
    {
        label: "Clearwater, BC",
        value: 8261,
    },
    {
        label: "Clements",
        value: 8731,
    },
    {
        label: "Clinton, BC",
        value: 8240,
    },
    {
        label: "Cloverdale",
        value: 8241,
    },
    {
        label: "Coal Harbour",
        value: 8465,
    },
    {
        label: "Cobble Hill",
        value: 8262,
    },
    {
        label: "Coldstream",
        value: 8299,
    },
    {
        label: "Columbia Gardens",
        value: 8263,
    },
    {
        label: "Colwood",
        value: 8368,
    },
    {
        label: "Comox",
        value: 8242,
    },
    {
        label: "Coombs",
        value: 8264,
    },
    {
        label: "Coquitlam",
        value: 8638,
    },
    {
        label: "Cortes Island",
        value: 8265,
    },
    {
        label: "Courtenay",
        value: 8246,
    },
    {
        label: "Cowichan Bay",
        value: 8371,
    },
    {
        label: "Cranbrook",
        value: 8248,
    },
    {
        label: "Crawford Bay",
        value: 8382,
    },
    {
        label: "Crescent Beach",
        value: 8266,
    },
    {
        label: "Creston, BC",
        value: 8250,
    },
    {
        label: "Crofton, BC",
        value: 8267,
    },
    {
        label: "Cultus Lake",
        value: 8384,
    },
    {
        label: "Cumberland, BC",
        value: 8256,
    },
    {
        label: "D'Arcy",
        value: 8385,
    },
    {
        label: "Dawson Creek, BC",
        value: 8270,
    },
    {
        label: "Dease Lake",
        value: 8386,
    },
    {
        label: "Deep Bay",
        value: 8271,
    },
    {
        label: "Delta",
        value: 8272,
    },
    {
        label: "Denman Island",
        value: 8277,
    },
    {
        label: "Deroche",
        value: 8273,
    },
    {
        label: "Dewdeny",
        value: 8275,
    },
    {
        label: "Douglas",
        value: 8276,
    },
    {
        label: "Duncan",
        value: 8274,
    },
    {
        label: "Dunster",
        value: 8278,
    },
    {
        label: "Eagle Bay, BC",
        value: 8280,
    },
    {
        label: "Eagle Creek",
        value: 8401,
    },
    {
        label: "East Pine",
        value: 8284,
    },
    {
        label: "Ebrune",
        value: 8286,
    },
    {
        label: "Edgewater",
        value: 8287,
    },
    {
        label: "Edgewood",
        value: 8403,
    },
    {
        label: "Elkford",
        value: 8288,
    },
    {
        label: "Elko",
        value: 8404,
    },
    {
        label: "Endako",
        value: 8289,
    },
    {
        label: "Enderby",
        value: 8290,
    },
    {
        label: "Erickson, BC",
        value: 8292,
    },
    {
        label: "Erikson",
        value: 8294,
    },
    {
        label: "Errington",
        value: 8293,
    },
    {
        label: "Esquimalt",
        value: 8678,
    },
    {
        label: "Fair. Hot Springs",
        value: 8405,
    },
    {
        label: "Falkland",
        value: 8296,
    },
    {
        label: "Fanny Bay",
        value: 8407,
    },
    {
        label: "Fauquier",
        value: 8409,
    },
    {
        label: "Femberton",
        value: 8298,
    },
    {
        label: "Fernie",
        value: 8300,
    },
    {
        label: "Forest Grove, BC",
        value: 8281,
    },
    {
        label: "Fort Fraser",
        value: 8302,
    },
    {
        label: "Fort Langley",
        value: 8301,
    },
    {
        label: "Fort Nelson",
        value: 8310,
    },
    {
        label: "Fort St James",
        value: 8314,
    },
    {
        label: "Fort St John",
        value: 8316,
    },
    {
        label: "Fort Steele",
        value: 8410,
    },
    {
        label: "Francois Lake",
        value: 8466,
    },
    {
        label: "Fraser Lake",
        value: 8320,
    },
    {
        label: "Fraser Mills",
        value: 8318,
    },
    {
        label: "Fraser Valley",
        value: 8321,
    },
    {
        label: "Fruitvale",
        value: 8322,
    },
    {
        label: "Fulford Harbor",
        value: 8323,
    },
    {
        label: "Furry Creek",
        value: 8291,
    },
    {
        label: "Gabriola",
        value: 8329,
    },
    {
        label: "Galiano Island",
        value: 8324,
    },
    {
        label: "Ganges",
        value: 8325,
    },
    {
        label: "Gar. Highlands",
        value: 8411,
    },
    {
        label: "Garden Bay",
        value: 8333,
    },
    {
        label: "Garibaldi",
        value: 8326,
    },
    {
        label: "Genelle",
        value: 8327,
    },
    {
        label: "Gibbons, BC",
        value: 8328,
    },
    {
        label: "Gibsons",
        value: 8330,
    },
    {
        label: "Gillies Bay",
        value: 8331,
    },
    {
        label: "Gold River",
        value: 8332,
    },
    {
        label: "Golden",
        value: 8334,
    },
    {
        label: "Goodlow",
        value: 8304,
    },
    {
        label: "Gr Birch",
        value: 8733,
    },
    {
        label: "Grand Forks",
        value: 8336,
    },
    {
        label: "Granisle",
        value: 8319,
    },
    {
        label: "Grasmere",
        value: 8335,
    },
    {
        label: "Gray Creek",
        value: 8337,
    },
    {
        label: "Greenwood, BC",
        value: 8338,
    },
    {
        label: "Grindrod",
        value: 8412,
    },
    {
        label: "Hagensborg",
        value: 8340,
    },
    {
        label: "Halfmoon Bay",
        value: 8342,
    },
    {
        label: "Hammond",
        value: 8346,
    },
    {
        label: "Hanceville",
        value: 8467,
    },
    {
        label: "Haney",
        value: 8339,
    },
    {
        label: "Harrison Hot Spri",
        value: 8350,
    },
    {
        label: "Harrison Mills",
        value: 8348,
    },
    {
        label: "Hazelton",
        value: 8352,
    },
    {
        label: "Hedley",
        value: 8413,
    },
    {
        label: "Heffley Creek",
        value: 8347,
    },
    {
        label: "Heriot Bay, BC",
        value: 8349,
    },
    {
        label: "Highlands",
        value: 8351,
    },
    {
        label: "Hixon",
        value: 8353,
    },
    {
        label: "Holberg",
        value: 8419,
    },
    {
        label: "Hope",
        value: 8354,
    },
    {
        label: "Hornby Island",
        value: 8355,
    },
    {
        label: "Horsefly",
        value: 8356,
    },
    {
        label: "Horseshoe Bay",
        value: 8468,
    },
    {
        label: "Houston",
        value: 8357,
    },
    {
        label: "Huds Hop",
        value: 8734,
    },
    {
        label: "Huntingdon, BC",
        value: 8358,
    },
    {
        label: "Invermere",
        value: 8360,
    },
    {
        label: "Inverness, BC",
        value: 8359,
    },
    {
        label: "Island Highway",
        value: 8362,
    },
    {
        label: "Jaffray",
        value: 8365,
    },
    {
        label: "Kalendan",
        value: 8369,
    },
    {
        label: "Kamloops",
        value: 8370,
    },
    {
        label: "Kaslo",
        value: 8372,
    },
    {
        label: "Katzie",
        value: 8373,
    },
    {
        label: "Kelowna",
        value: 8374,
    },
    {
        label: "Keremeos",
        value: 8376,
    },
    {
        label: "Kimberley",
        value: 8378,
    },
    {
        label: "Kingsgate",
        value: 8375,
    },
    {
        label: "Kinnaird",
        value: 8380,
    },
    {
        label: "Kitimat",
        value: 8379,
    },
    {
        label: "Kitwanga",
        value: 8377,
    },
    {
        label: "Kleena Kleene",
        value: 8431,
    },
    {
        label: "Kootenay Bay",
        value: 8433,
    },
    {
        label: "La Hache",
        value: 8735,
    },
    {
        label: "Ladner",
        value: 8381,
    },
    {
        label: "Ladysmith",
        value: 8390,
    },
    {
        label: "Lake Country",
        value: 8435,
    },
    {
        label: "Lake Cowichan",
        value: 8392,
    },
    {
        label: "Langley",
        value: 8640,
    },
    {
        label: "Lantzville",
        value: 8393,
    },
    {
        label: "Lasqueti Island",
        value: 8391,
    },
    {
        label: "Latham",
        value: 8388,
    },
    {
        label: "Laurier",
        value: 8394,
    },
    {
        label: "Lazo",
        value: 8389,
    },
    {
        label: "Lehman",
        value: 8395,
    },
    {
        label: "Lillooet",
        value: 8396,
    },
    {
        label: "Lindell Beach",
        value: 8305,
    },
    {
        label: "Lion's Bay",
        value: 8398,
    },
    {
        label: "Lister",
        value: 8387,
    },
    {
        label: "Little Fort",
        value: 8397,
    },
    {
        label: "Logan Lake",
        value: 8400,
    },
    {
        label: "Lone Butte",
        value: 8402,
    },
    {
        label: "Lower Nicola",
        value: 8306,
    },
    {
        label: "Lumby",
        value: 8406,
    },
    {
        label: "Lund",
        value: 8436,
    },
    {
        label: "Lytton",
        value: 8408,
    },
    {
        label: "Mackenzie",
        value: 8414,
    },
    {
        label: "Madeira Park",
        value: 8415,
    },
    {
        label: "Malahat",
        value: 8437,
    },
    {
        label: "Malakwa",
        value: 8438,
    },
    {
        label: "Mansos Landing",
        value: 8416,
    },
    {
        label: "Maple Ridge",
        value: 8642,
    },
    {
        label: "Mara",
        value: 8418,
    },
    {
        label: "Marysville, BC",
        value: 8420,
    },
    {
        label: "Masset",
        value: 8422,
    },
    {
        label: "Matsqui",
        value: 8421,
    },
    {
        label: "Mayne Lake",
        value: 8439,
    },
    {
        label: "Mc Millian Isl",
        value: 8425,
    },
    {
        label: "McBride",
        value: 8424,
    },
    {
        label: "Mcleese Lake",
        value: 8440,
    },
    {
        label: "Meadow Creek",
        value: 8441,
    },
    {
        label: "Merritt",
        value: 8426,
    },
    {
        label: "Merville",
        value: 8427,
    },
    {
        label: "Midway",
        value: 8428,
    },
    {
        label: "Milhouse",
        value: 8429,
    },
    {
        label: "Mill Bay",
        value: 8430,
    },
    {
        label: "Mission",
        value: 8644,
    },
    {
        label: "Moberly Lake",
        value: 8442,
    },
    {
        label: "Montney",
        value: 8443,
    },
    {
        label: "Montrose",
        value: 8432,
    },
    {
        label: "Moyle Lake",
        value: 8434,
    },
    {
        label: "Nakusp",
        value: 8450,
    },
    {
        label: "Nanaimo",
        value: 8452,
    },
    {
        label: "Nanoose Bay",
        value: 8451,
    },
    {
        label: "Naramata",
        value: 8453,
    },
    {
        label: "Nelson, BC",
        value: 8454,
    },
    {
        label: "Nelway",
        value: 8455,
    },
    {
        label: "New Aiyansh",
        value: 8458,
    },
    {
        label: "New Denver",
        value: 8456,
    },
    {
        label: "New Hazelton",
        value: 8460,
    },
    {
        label: "New Westminster",
        value: 8646,
    },
    {
        label: "Nig Creek",
        value: 8739,
    },
    {
        label: "Nimpo",
        value: 8462,
    },
    {
        label: "North Delta",
        value: 8295,
    },
    {
        label: "North Pine",
        value: 8464,
    },
    {
        label: "North Saanich",
        value: 8680,
    },
    {
        label: "North Vancouver",
        value: 8648,
    },
    {
        label: "Oak Bay, BC",
        value: 8682,
    },
    {
        label: "Ocean Falls",
        value: 8472,
    },
    {
        label: "Okanagan",
        value: 8476,
    },
    {
        label: "Okanagan Falls",
        value: 8474,
    },
    {
        label: "Oliver",
        value: 8480,
    },
    {
        label: "Osoyoos",
        value: 8482,
    },
    {
        label: "Other",
        value: 8999,
    },
    {
        label: "Oyama",
        value: 8484,
    },
    {
        label: "Panorama",
        value: 8307,
    },
    {
        label: "Parksville",
        value: 8500,
    },
    {
        label: "Paterson",
        value: 8498,
    },
    {
        label: "Peachland",
        value: 8499,
    },
    {
        label: "Pemberton",
        value: 8502,
    },
    {
        label: "Pender Island",
        value: 8501,
    },
    {
        label: "Penticton",
        value: 8504,
    },
    {
        label: "Pink Mountain",
        value: 8444,
    },
    {
        label: "Pitt Meadows",
        value: 8650,
    },
    {
        label: "Pleasant Camp",
        value: 8503,
    },
    {
        label: "Point Roberts",
        value: 8505,
    },
    {
        label: "Port Alberni",
        value: 8508,
    },
    {
        label: "Port Alice",
        value: 8510,
    },
    {
        label: "Port Clements",
        value: 8512,
    },
    {
        label: "Port Coquitlam",
        value: 8652,
    },
    {
        label: "Port Edward",
        value: 8514,
    },
    {
        label: "Port Hardy",
        value: 8654,
    },
    {
        label: "Port Hawksbury",
        value: 8515,
    },
    {
        label: "Port Mcneill",
        value: 8516,
    },
    {
        label: "Port Moody",
        value: 8518,
    },
    {
        label: "Pouce Coupe",
        value: 8520,
    },
    {
        label: "Powell River",
        value: 8522,
    },
    {
        label: "Prince George",
        value: 8524,
    },
    {
        label: "Prince Rupert",
        value: 8526,
    },
    {
        label: "Princeton, BC",
        value: 8528,
    },
    {
        label: "Pritchard",
        value: 8445,
    },
    {
        label: "Proctor",
        value: 8530,
    },
    {
        label: "Quadra Island",
        value: 8446,
    },
    {
        label: "Qualicum Beach",
        value: 8540,
    },
    {
        label: "Quathiaski Cove",
        value: 8536,
    },
    {
        label: "Quatsino",
        value: 8538,
    },
    {
        label: "Queen Charlotte",
        value: 8541,
    },
    {
        label: "Quesnel",
        value: 8542,
    },
    {
        label: "Quilchena",
        value: 8544,
    },
    {
        label: "Radium Hot Springs",
        value: 8546,
    },
    {
        label: "Revelstoke",
        value: 8550,
    },
    {
        label: "Richmond, BC",
        value: 8656,
    },
    {
        label: "Robert C",
        value: 8737,
    },
    {
        label: "Robson",
        value: 8551,
    },
    {
        label: "Rock Creek",
        value: 8548,
    },
    {
        label: "Roosville",
        value: 8552,
    },
    {
        label: "Rosedale",
        value: 8553,
    },
    {
        label: "Rossland",
        value: 8554,
    },
    {
        label: "Royston",
        value: 8308,
    },
    {
        label: "Ruskin",
        value: 8556,
    },
    {
        label: "Rykerts",
        value: 8558,
    },
    {
        label: "Saanich",
        value: 8684,
    },
    {
        label: "Saanichton",
        value: 8560,
    },
    {
        label: "Salmo",
        value: 8570,
    },
    {
        label: "Salmon Arm",
        value: 8564,
    },
    {
        label: "Salt Spring Isl.",
        value: 8566,
    },
    {
        label: "Sandpit",
        value: 8568,
    },
    {
        label: "Sardis",
        value: 8569,
    },
    {
        label: "Saturna Island",
        value: 8571,
    },
    {
        label: "Savona",
        value: 8469,
    },
    {
        label: "Sayward",
        value: 8572,
    },
    {
        label: "Seal Cove, BC",
        value: 8573,
    },
    {
        label: "Sechelt",
        value: 8574,
    },
    {
        label: "Semiahmoo",
        value: 8575,
    },
    {
        label: "Sewell Inlet",
        value: 8579,
    },
    {
        label: "Shawnigan Lake",
        value: 8576,
    },
    {
        label: "Shuswap",
        value: 8577,
    },
    {
        label: "Sicamous",
        value: 8686,
    },
    {
        label: "Sidney",
        value: 8688,
    },
    {
        label: "Silverton",
        value: 8578,
    },
    {
        label: "Skidegate",
        value: 8447,
    },
    {
        label: "Skookumchuck",
        value: 8448,
    },
    {
        label: "Slocan",
        value: 8580,
    },
    {
        label: "Smithers",
        value: 8582,
    },
    {
        label: "Sointula",
        value: 8738,
    },
    {
        label: "Sooke",
        value: 8583,
    },
    {
        label: "Sorrento",
        value: 8567,
    },
    {
        label: "South Fort George",
        value: 8584,
    },
    {
        label: "Sparwood",
        value: 8585,
    },
    {
        label: "Spences Bridge",
        value: 8589,
    },
    {
        label: "Squamish",
        value: 8586,
    },
    {
        label: "Stave Falls",
        value: 8587,
    },
    {
        label: "Stewart",
        value: 8588,
    },
    {
        label: "Stikine",
        value: 8590,
    },
    {
        label: "Sullivan Bay",
        value: 8592,
    },
    {
        label: "Summerland",
        value: 8594,
    },
    {
        label: "Sun Peaks",
        value: 8309,
    },
    {
        label: "Surge Narrows",
        value: 8596,
    },
    {
        label: "Surrento",
        value: 8598,
    },
    {
        label: "Surrey, BC",
        value: 8658,
    },
    {
        label: "Ta Ta Creek",
        value: 8599,
    },
    {
        label: "Tahsis",
        value: 8600,
    },
    {
        label: "Tappen",
        value: 8690,
    },
    {
        label: "Tasu",
        value: 8692,
    },
    {
        label: "Tatla Lake",
        value: 8694,
    },
    {
        label: "Taylor",
        value: 8602,
    },
    {
        label: "Telegraph Creek",
        value: 8741,
    },
    {
        label: "Telkwa",
        value: 8604,
    },
    {
        label: "Terrace",
        value: 8605,
    },
    {
        label: "TÃªte Jaune Cache",
        value: 8603,
    },
    {
        label: "Thetis Island",
        value: 8282,
    },
    {
        label: "Thompson, BC",
        value: 8696,
    },
    {
        label: "T'Kumlups",
        value: 8742,
    },
    {
        label: "Tlell",
        value: 8470,
    },
    {
        label: "Tofino",
        value: 8606,
    },
    {
        label: "Trail",
        value: 8608,
    },
    {
        label: "Tsawwassen",
        value: 8607,
    },
    {
        label: "Tsay Keh",
        value: 8743,
    },
    {
        label: "Tumbler",
        value: 8698,
    },
    {
        label: "Tumbler Ridge",
        value: 8699,
    },
    {
        label: "Ucluelet",
        value: 8620,
    },
    {
        label: "Union Bay",
        value: 8622,
    },
    {
        label: "Valemount",
        value: 8630,
    },
    {
        label: "Vananda",
        value: 8632,
    },
    {
        label: "Vancouver",
        value: 8634,
    },
    {
        label: "Vanderhoof",
        value: 8670,
    },
    {
        label: "Vavenby",
        value: 8633,
    },
    {
        label: "Vernon",
        value: 8672,
    },
    {
        label: "Victoria, BC",
        value: 8674,
    },
    {
        label: "Waglisla, BC",
        value: 8283,
    },
    {
        label: "Waneta",
        value: 8701,
    },
    {
        label: "Warfield",
        value: 8700,
    },
    {
        label: "Wasa Lake",
        value: 8703,
    },
    {
        label: "Webster's Corner",
        value: 8706,
    },
    {
        label: "Wells",
        value: 8707,
    },
    {
        label: "West Vancouver",
        value: 8660,
    },
    {
        label: "Westbank",
        value: 8708,
    },
    {
        label: "Westbridge",
        value: 8312,
    },
    {
        label: "Westminister",
        value: 8709,
    },
    {
        label: "Westwold",
        value: 8449,
    },
    {
        label: "Whaletown",
        value: 8711,
    },
    {
        label: "Whistler",
        value: 8712,
    },
    {
        label: "White Rock",
        value: 8702,
    },
    {
        label: "Whonnock",
        value: 8635,
    },
    {
        label: "Williams Lake",
        value: 8704,
    },
    {
        label: "Willow River",
        value: 8714,
    },
    {
        label: "Windermere",
        value: 8715,
    },
    {
        label: "Winfield, BC",
        value: 8716,
    },
    {
        label: "Winlaw",
        value: 8717,
    },
    {
        label: "Wonowon",
        value: 8457,
    },
    {
        label: "Woss",
        value: 8315,
    },
    {
        label: "Wyndel",
        value: 8718,
    },
    {
        label: "Yahk",
        value: 8459,
    },
    {
        label: "Yale",
        value: 8461,
    },
    {
        label: "Yarrow",
        value: 8719,
    },
    {
        label: "Ymir",
        value: 8463,
    },
    {
        label: "Youbou",
        value: 8721,
    },
    {
        label: "Zeballos",
        value: 8710,
    },
];
